export default (node) => {
  const localizeButton = node.querySelector('[data-localize-button]');
  const localizeMenu = node.querySelector('[data-localize-menu]');
  const localizeButtonChange = node.querySelectorAll(
    '[data-change-locale]'
  );
  const localeCode = node.querySelector('[data-locale-code]');
  const countryCode = node.querySelector('[data-country-code]');
  const localizeForm = node.querySelector('form');

  const closeMenu = () => {
    localizeMenu.classList.add('hidden');
  };

  const toggleLocalizeMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();

    localizeMenu.classList.toggle('hidden');
    localizeMenu.classList.toggle('border-solid', 'border-2', 'border-gray-90');

    if (!localizeMenu.classList.contains('hidden')) {
      document.dispatchEvent(new CustomEvent('help-menu:close'));
    }
  };

  const goToStore = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const newLanguageCode = e.currentTarget.getAttribute('data-localize-button-language-code');
    const newCountryCode = e.currentTarget.getAttribute('data-localize-button-country-code');

    localeCode.value = newLanguageCode;
    countryCode.value = newCountryCode;

    localizeForm.submit();
  };

  const init = () => {
    if (localizeButton)
      localizeButton.addEventListener('click', toggleLocalizeMenu);

    if (localizeButtonChange) {
      localizeButtonChange.forEach((button) => {
        button.addEventListener('click', goToStore);
      });
    }

    document.addEventListener('localize-menu:close', closeMenu);
  };

  init();
};
